var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"error-page",attrs:{"justify":"center","align":"center"}},[_c('span',{staticClass:"error-page--status"},[_vm._v(_vm._s(_vm.$route.params.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }